import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import React from "react";
import { setLogoutUser } from "../reducers/users/userSlices";
import { setLogoutUserSession } from "../reducers/sessions/sessionauthcodeSlices";
import { setLogoutAuthCode } from "../reducers/authorization/authorizationcodeSlices";
import LogoutIcon from "@mui/icons-material/Logout";
import { CleanReprintReportData } from "../reducers/reports/reprintreport";
import { cleanCodeAuth } from "../reducers/authorization/codeauthorizationSlices";
//import { setCleanServices } from "../reducers/services/addservicesSlices";
import { cleanUpdateAuth } from "../reducers/authorization/updateautorizacionSlices";
import { setEmptyServices } from "../reducers/services/servicesSlices";

const LogoutButton = () => {
  const navigate = useNavigate();

  const { plastico, mensage } = useSelector((state) => state.authcode);
  const { codauth, message } = useSelector((state) => state.codeauth);
  const { autorizacion, coddia, telefono, diagno, mesage } = useSelector(
    (state) => state.updateauth
  );
  const { reprintdata } = useSelector((state) => state.reprint);
  //const { addservices } = useSelector((state) => state.addservices);
  const { services } = useSelector((state) => state.services);
  const { usersession } = useSelector((state) => state.sessionuser);
  const { usuario, clave, codPss, descripcion, token } = useSelector((state) => state.user);

  const dispatch = useDispatch();

  const LogoutUser = () => {
    Swal.fire({
      title: "¿Estás seguro de que quieres cerrar la sesión?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("", "sesión cerrada.", "success");

        dispatch(
          setLogoutAuthCode({
            plastico: plastico,
            mensage: mensage,
          })
        );

        dispatch(
          cleanCodeAuth({
            codauth: codauth,
            message: message,
          })
        );

        dispatch(
          cleanUpdateAuth({
            autorizacion: autorizacion,
            coddia: coddia,
            telefono: telefono,
            diagno: diagno,
            mesage: mesage,
          })
        );

        dispatch(
          CleanReprintReportData({
            reprintdata: reprintdata,
          })
        );

        dispatch(setEmptyServices(services));

        dispatch(
          setLogoutUserSession({
            usersession: usersession,
          })
        );

        dispatch(
          setLogoutUser({
            usuario: usuario,
            clave: clave,
            codPss: codPss,
            descripcion: descripcion,
            token: token,
          })
        );

        // Cerrar sesión, eliminar el token de sesión
        localStorage.removeItem("sessionToken");
        localStorage.setItem('sessionActive', 'false');

        setTimeout(() => {
          navigate("/");
          window.location.reload();
        }, 1500);
      }
    });
  };

  return (
    <Box
      sx={{
        marginTop: 6,
      }}
    >
      <Button
        variant="contained"
        style={{
          marginLeft: "10px",
          color: "white",
          background: "#212529",
          position: "absolute",
          textTransform: "none",
        }}
        onClick={LogoutUser}
      >
        <LogoutIcon style={{ marginRight: "20px", color: "white" }} /> Salir
      </Button>

      <Button
        variant="contained"
        sx={{
          width: "auto",
          display: { xs: "flex", sm: "flex", md: "none", lg: "none" },
          marginLeft: "10",
          mb: 2,
          color: "white",
          background: "#212529",
          position: "absolute",
        }}
        onClick={LogoutUser}
      >
        <LogoutIcon />
      </Button>
    </Box>
  );
};

export default LogoutButton;
